import React from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  BulbOutlined,
  DashboardOutlined,
  LogoutOutlined,
  PictureOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import PageErrorBoundary from "./PageErrorBoundary";
import "./admin.css";

const NAV = [
  { to: "/home", label: "Dashboard", icon: <DashboardOutlined /> },
  { to: "/allDonor", label: "Donors", icon: <TeamOutlined /> },
  { to: "/gallary", label: "Gallery", icon: <PictureOutlined /> },
  { to: "/others", label: "Suggestions", icon: <BulbOutlined /> },
];

// Layout for every admin page: a sidebar on desktop, a top bar with a
// scrollable nav on phones. Pages render into <Outlet />.
const AdminShell = ({ admin, setUser }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const logout = () => {
    localStorage.removeItem("blood-token");
    setUser(null);
    navigate("/admin-login");
  };

  return (
    <div className="adm">
      <aside className="adm-side">
        <div className="adm-brand">
          <span className="adm-brand__mark">0709</span>
          <span className="adm-brand__tag">Admin</span>
        </div>
        <nav className="adm-nav" aria-label="Admin">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `adm-nav__link ${isActive ? "adm-nav__link--active" : ""}`}
            >
              <span className="adm-nav__icon">{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="adm-account">
          <span className="adm-account__avatar">
            <UserOutlined />
          </span>
          <span className="adm-account__name" title={admin?.name}>
            {admin?.name || "Admin"}
          </span>
          <button type="button" className="adm-account__logout" onClick={logout} aria-label="Log out">
            <LogoutOutlined />
          </button>
        </div>
      </aside>

      <main className="adm-main">
        <PageErrorBoundary resetKey={location.pathname}>
          <Outlet />
        </PageErrorBoundary>
      </main>
    </div>
  );
};

// Page title row shared by the admin pages.
export const AdminPageHeader = ({ title, subtitle, actions }) => (
  <div className="adm-page-head">
    <div>
      <h1 className="adm-page-head__title">{title}</h1>
      {subtitle ? <p className="adm-page-head__sub">{subtitle}</p> : null}
    </div>
    {actions ? <div className="adm-page-head__actions">{actions}</div> : null}
  </div>
);

export default AdminShell;
